import { MANTY_AUTH } from 'business/constants';
import {
    CreateMultipleUserState,
    CreateMultipleUserAction,
    CreateMultipleUserActionType,
    UserCreationType,
} from './types';

export const defaultUser: UserCreationType = {
    gender: 'M',
    email: '',
    roles: [],
    firstname: '',
    lastname: '',
    job: '',
    authMethods: [MANTY_AUTH],
};

const fillUserDefault = (
    user: Partial<UserCreationType>,
): UserCreationType => ({
    ...defaultUser,
    ...user,
});

// We can remove this function when TS / Babel start supporting `.with`.
const replaceAt = <T,>(arr: T[], idx: number, val: T): T[] => [
    ...arr.slice(0, idx),
    val,
    ...arr.slice(idx + 1),
];

export const multipleUserCreationReducer = (
    state: CreateMultipleUserState,
    action: CreateMultipleUserAction,
): CreateMultipleUserState => {
    switch (action.type) {
        case CreateMultipleUserActionType.addUser:
            return {
                ...state,
                users: [...state.users, fillUserDefault(action.user)],
                isDirty: true,
            };
        case CreateMultipleUserActionType.replaceUsers:
            return {
                ...state,
                users: action.users.map((usr) => fillUserDefault(usr)),
                isDirty: true,
            };
        case CreateMultipleUserActionType.updateUser: {
            const currUser = state.users.at(action.index);
            if (currUser === undefined) {
                return { ...state };
            }
            const updatedUser = {
                ...currUser,
                ...action.user,
            };
            return {
                ...state,
                users: replaceAt(state.users, action.index, updatedUser),
                isDirty: true,
            };
        }
        case CreateMultipleUserActionType.removeUser:
            return {
                ...state,
                users: state.users.filter(
                    (_, idx: number) => idx !== action.index,
                ),
                isDirty: true,
            };
        case CreateMultipleUserActionType.addRole:
            return {
                ...state,
                users: state.users.map((user) => {
                    if (user.roles.includes(action.role)) {
                        return user;
                    }
                    return { ...user, roles: [...user.roles, action.role] };
                }),
                isDirty: true,
            };
        case CreateMultipleUserActionType.removeRole:
            return {
                ...state,
                users: state.users.map((user) => ({
                    ...user,
                    roles: user.roles.filter((r) => r !== action.role),
                })),
                isDirty: true,
            };
        case CreateMultipleUserActionType.setSendEmail:
            return {
                ...state,
                shouldSendEmail: action.shouldSendEmail,
                isDirty: true,
            };
        case CreateMultipleUserActionType.changeAuthMethod:
            return {
                ...state,
                users: state.users.map((user) => ({
                    ...user,
                    authMethods: [action.authMethod],
                })),
                isDirty: true,
            };
        default:
            return { ...state };
    }
};
